import React, { Component } from "react";
import QrScanner from "react-qr-scanner"; // Import the correct component

class QRScanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: "",
      scanning: true, // Flag to control scanning
    };
  }

  handleScan = (data) => {
    if (data) {
      this.setState({ result: data.text || data, scanning: false }); // Update result in state and stop scanning
      console.log("QR Code Result:", data.text || data);
    }
  };

  handleError = (err) => {
    console.error("QR Code Error:", err.message || "Unknown error");
  };

  resetScanner = () => {
    this.setState({ result: "", scanning: true }); // Reset the scanner
  };

  render() {
    return (
      <div>
        <h1>QR Code Scanner</h1>
        {this.state.scanning ? (
          <QrScanner
            onScan={this.handleScan} // Use onScan instead of onResult
            onError={this.handleError} // Use onError for error handling
            className="qr-scanner" // Use the CSS class
            style={{ width: "150px", height: "150px" }} // Set size directly
          />
        ) : (
          <div>
            <p>Scanned Result: {this.state.result}</p> {/* Display the result */}
            <button onClick={this.resetScanner}>Scan Again</button>
          </div>
        )}
      </div>
    );
  }
}

export default QRScanner;